import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './Spinner.module.scss'

interface ISpinnerProps {
  // The box of the block it stands in for, so nothing moves when the content arrives; without one the
  // spinner takes a page-sized box.
  className?: string
}

// Costco's loader: a short blue arc with no track, centred in the block it stands in for.
const Spinner = ({ className }: ISpinnerProps) => {
  const { t } = useSurveyLocale()

  return (
    <div
      className={`${style.box} ${className || style.page}`}
      role="status"
      aria-label={t('questions', 'ec', 'loading')}
      data-testid="SW-EC-Spinner"
    >
      <svg className={style.ring} viewBox="0 0 32 32" aria-hidden="true">
        <circle className={style.arc} cx="16" cy="16" r="14.5" pathLength="100" />
      </svg>
    </div>
  )
}

export default Spinner
